<template>
  <div>
    <div class="d-flex justify-content-between align-items-center">
      <SectionTitle class="mb-2">
        進路活動記録
      </SectionTitle>
      <CollapseButton
        :open="isCollapseOpen"
        @click="isCollapseOpen = !isCollapseOpen" />
    </div>
    <p class="fs-s pb-2">
      ※〇〇の練習会に参加、英検3級合格などを入力
    </p>
    <b-collapse
      :visible="isCollapseOpen">
      <div
        class="d-flex flex-column"
        style="gap: 8px;">
        <PathActivityItem
          v-for="pathActivity in pathActivities"
          :id="pathActivity.id"
          :key="pathActivity.id"
          :can-edit="canEdit"
          :path-activity="pathActivity" />
      </div>
      <LinkButton
        v-if="canEdit"
        class="my-2"
        :to="`/members/${userId}/profile/path_activities/add`">
        <RoundedIcon
          class="mr-2"
          color="l-blue"
          icon="add" />
        活動記録を追加
      </LinkButton>
      <slot name="comments" />
    </b-collapse>
  </div>
</template>

<script>
import SectionTitle from '@/components/view/profile/SectionTitle.vue'
import RoundedIcon from '@/components/parts/RoundedIcon.vue'
import LinkButton from '@/components/parts/LinkButton.vue'
import CollapseButton from '@/components/view/profile/CollapseButton.vue'
import PathActivityItem from '@/components/view/profile/path_activities/PathActivityItem.vue'
export default {
  name: 'PathActivitiesSection',
  components: {
    SectionTitle,
    RoundedIcon,
    LinkButton,
    PathActivityItem,
    CollapseButton
  },
  props: {
    canEdit: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: String,
      required: true
    },
    pathActivities: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isCollapseOpen: true,
    }
  },
}
</script>

<style>

</style>